import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import PageContentEditor from "../../../components/PageContentEditor";
import { DataCodeEnum } from "../../../constants/enum";
import DataContent from "../../../components/DataContent";
// import WhatIs from "./components/WhatIs";
// import LifePathNumber from "./components/LifePathNumber";

// import ZodiacList from "./components/ZodiacList";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
      }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ width: "100%", height: "100%" }}>{children}</Box>
      )}
    </Box>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const IndicatorsExpression = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const tabs = [
    {
      code: "HOW_TO",
      name: "How to calculate expression number",
      component: () => (
        <PageContentEditor
          dataCode={
            DataCodeEnum.NUMEROLOGY_INDICATORS_EXPRESSION_HOW_TO_CALCULATE
          }
          dataName={"How to calculate expression number"}
        />
      ),
    },
    {
      code: "Expression",
      name: "Expression 1,2,3,4,5,6,7,8,9,11,22,33",
      component: () => (
        <DataContent
          code={DataCodeEnum.NUMEROLOGY_INDICATORS_EXPRESSION}
          name={"Expression 1,2,3,4,5,6,7,8,9,11,22,33"}
          fields={[
            {
              code: "name",
              name: "Name",
            },
            {
              code: "description",
              name: "Description",
            },
          ]}
        />
      ),
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map((tab, index) => (
            <Tab
              label={tab.name}
              {...a11yProps(index)}
              sx={{
                textTransform: "unset",
                "&.Mui-selected": {
                  fontWeight: "bold",
                },
              }}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <CustomTabPanel value={value} index={index}>
          {<tab.component />}
        </CustomTabPanel>
      ))}
    </Box>
  );
};

export default IndicatorsExpression;
